// @flow
import * as React from 'react';
import ShapeSetDetailsForm from './ShapeSetDetailsForm';

type Props = {
  currentShapeSet: Object,
  params: {
    context: string,
    organisationId: string,
    shapeSetId: string
  },
  router: Object,
  authentication: Object,
  getShapeSetSettings: Function,
  updateShapeSet: Function,
  addShapeSet: Function
};

type State = {
  isSaving: boolean,
  errorMsg?: string,
  successMsg?: string
};

export default class ShapeSetDetails extends React.Component<Props, State> {
  static displayName = 'ShapeSetDetails';
  timeoutId: any;
  screenReaderContent: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      isSaving: false,
      errorMsg: undefined,
      successMsg: undefined
    };
    this.timeoutId = undefined;
  }

  componentDidMount() {
    const context = this.props.params.context;
    this.props.getShapeSetSettings(context);

    this.screenReaderContent.focus();
  }

  componentWillUnmount() {
    // clear timeout to prevent setState on unmounted component
    clearTimeout(this.timeoutId);
  }

  handleSubmit = (values: Object) => {
    this.setState({ isSaving: true, errorMsg: undefined });
    const { isInternalAdminUser } = this.props.authentication.user;
    const { context, organisationId } = this.props.params;
    if (!isInternalAdminUser) {
      // hardcode to location if user is not an internalAdminUser
      values.shapeSetTypeId = 1;
    }

    if (values.id) {
      this.props
        .updateShapeSet(values, context)
        .then(
          response => this.success(response, context, organisationId, false),
          error => this.failure(error)
        );
    } else {
      this.props
        .addShapeSet(values, context)
        .then(
          response => this.success(response, context, organisationId, true),
          error => this.failure(error)
        );
    }
  };

  success = (
    response: Object,
    context: string,
    organisationId: string | number = 0,
    redirect: boolean = false
  ) => {
    this.setState({
      isSaving: false,
      errorMsg: undefined,
      successMsg: 'Success!'
    });
    this.timeoutId = setTimeout(
      () => this.setState({ successMsg: undefined }),
      3000
    );

    if (redirect) {
      const newShapeSetId = response.data.id;
      const shapeSetUrl = `/${context}/${organisationId}/catchment-sets/${newShapeSetId}`;
      this.props.router.push(shapeSetUrl);
    }
  };

  failure = (error: Object) => {
    this.setState({ isSaving: false, errorMsg: error.data.message });
  };

  render() {
    const context = this.props.params.context;
    const isNew = this.props.params.shapeSetId === 'new';
    const { isInternalAdminUser } = this.props.authentication.user;
    const canEdit =
      context === 'global' || this.props.currentShapeSet.isOwner || isNew;
    return (
      <div>
        <h3
          className="screen-reader-only"
          tabIndex="-1"
          ref={i => (this.screenReaderContent = i)}
        >
          Showing details for catchment set {this.props.currentShapeSet.name}
        </h3>
        <ShapeSetDetailsForm
          onSubmit={this.handleSubmit}
          initialValues={this.props.currentShapeSet}
          enableReinitialize={true}
          currentShapeSet={this.props.currentShapeSet}
          isNew={this.props.params.shapeSetId === 'new'}
          isOwner={canEdit}
          isSaving={this.state.isSaving}
          errorMsg={this.state.errorMsg}
          successMsg={this.state.successMsg}
          context={context}
          isInternalAdminUser={isInternalAdminUser}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/shapeset/ShapeSetDetails.js